import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Navigation from './Navigation';
import Footer from './Footer';
import './App.css';

function HowItWorks() {
  const [openFAQ, setOpenFAQ] = useState(null);

  // Toggle FAQ item
  const toggleFAQ = (index) => {
    setOpenFAQ(openFAQ === index ? null : index);
  };

  // FAQ data
  const faqs = [
    {
      question: "How far in advance should I book my wedding car?",
      answer: "We recommend booking your wedding car at least 1 month in advance, especially if your wedding is during peak season (October to March). This ensures you get your preferred vehicle and allows time for customization requests."
    },
    {
      question: "What is included in the rental price?",
      answer: "Our rental prices include the vehicle, professional chauffeur, fuel for the specified hours and kilometers and basic decoration for couple vehicles. Additional decorations, extended hours, and extra kilometers can be arranged at additional cost."
    },
    {
      question: "Can I customize the car decoration?",
      answer: "Yes! We offer a wide selection of decoration options for each vehicle. You can also request custom decorations to match your wedding theme. Our relationship manager will work with you to understand your preferences and coordinate the decorations."
    },
    {
      question: "What happens if the car breaks down on my wedding day?",
      answer: "We maintain our vehicles to the highest standards to prevent such situations. However, in the unlikely event of a breakdown, we have backup vehicles ready and will arrange an immediate replacement at no additional cost to ensure your schedule is not affected."
    },
    {
      question: "In what cities do you provide services?",
      answer: "We have an all India coverage. All Tier 1 & Tier 2 cities are covered, along with coverage for other cities. Car availability varies from city to city. Please discuss your requirements with our relationship manager to check for exact availability."
    },
    {
      question: "What is your cancellation policy?",
      answer: "Cancellations made 7 days or more before the event will receive a full refund minus a ₹300 processing fee. Cancellations between 7 days and 72 hours result in forfeiture of the deposit amount. Cancellations with less than 72 hours notice will result in forfeiture of the entire amount."
    },
    {
      question: "Can I have a trial/preview of the car before the wedding?",
      answer: "Yes, we encourage clients to view their selected vehicle before the wedding day. You can schedule an appointment with our relationship manager to inspect the car and discuss any specific requirements or concerns you may have."
    },
    {
      question: "Are the chauffeurs experienced with wedding events?",
      answer: "All our chauffeurs are professionally trained and have extensive experience with wedding events. They understand the importance of punctuality, proper dress code, and maintaining the elegance of your special day. They will coordinate with your wedding planner as needed."
    }
  ];

  // Reusable header component
  const Header = ({ children }) => (
    <header className="App-header">
      {children}
    </header>
  );

  return (
    <div className="App">
      <Navigation />
      <Header>
        <div className="page-content">
          <h2 className="section-title">How It Works</h2>
          
          <div className="how-it-works-container">
            <div className="step-row">
              <div className="step-image">
                <img src="/images/select-vehicle.png" alt="Select Your Vehicle" />
              </div>
              <div className="step">
                <h3 className="step-number">1</h3>
                <h4 className="step-title">Select Your Vehicle</h4>
                <p className="step-description">
                  Browse through our premium collection of wedding vehicles. Choose from our carefully 
                  curated categories and view detailed specifications, features, and high-quality images 
                  to find the perfect match for your celebration.
                </p>
              </div>
            </div>

            <div className="step-row reverse">
              <div className="step-image">
                <img src="/images/relationship-manager.png" alt="Connect with our Relationship Manager" />
              </div>
              <div className="step">
                <h3 className="step-number">2</h3>
                <h4 className="step-title">Connect with your Relationship Manager</h4>
                <p className="step-description">
                  Once you've selected your preferred vehicle, our dedicated relationship manager will 
                  reach out to you. They'll understand your specific requirements, provide personalized 
                  recommendations, and guide you through the entire process.
                </p>
              </div>
            </div>

            <div className="step-row">
              <div className="step-image">
                <img src="/images/book-n-confirm.png" alt="Book & Confirm" />
              </div>
              <div className="step">
                <h3 className="step-number">3</h3>
                <h4 className="step-title">Book & Confirm</h4>
                <p className="step-description">
                  Work with your relationship manager to finalize all details including dates, timings, 
                  pickup locations, and special requirements. Complete the booking process and receive 
                  confirmation for your wedding day transportation.
                </p>
              </div>
            </div>

            <div className="step-row reverse">
              <div className="step-image">
                <img src="/images/wedding-day.png" alt="Enjoy Your Day" />
              </div>
              <div className="step">
                <h3 className="step-number">4</h3>
                <h4 className="step-title">Enjoy Your Day</h4>
                <p className="step-description">
                  On your wedding day, our professional chauffeurs will arrive on time with your 
                  chosen vehicle, ensuring a memorable and stress-free transportation experience.
                </p>
              </div>
            </div>
          </div>

          <div className="cta-section">
            <h3>Ready to Get Started?</h3>
            <p>Chat with our expert to plan the perfect transport for your wedding day</p>
            <Link to="https://api.whatsapp.com/message/JSEYCETSCIAIB1" className="cta-button">Chat on WhatsApp</Link>
          </div>

          <div className="faq-section">
            <h2 className="section-title">Frequently Asked Questions</h2>
            <div className="faq-container">
              {faqs.map((faq, index) => (
                <div key={index} className={`faq-item ${openFAQ === index ? 'active' : ''}`}>
                  <button 
                    className="faq-question" 
                    onClick={() => toggleFAQ(index)}
                    aria-expanded={openFAQ === index}
                  >
                    <span>{faq.question}</span>
                    <span className="faq-icon">{openFAQ === index ? '−' : '+'}</span>
                  </button>
                  <div className={`faq-answer ${openFAQ === index ? 'open' : ''}`}>
                    <p>{faq.answer}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </Header>
      
      <Footer />
    </div>
  );
}

export default HowItWorks;
